export default function initQRCodeGenerator() {
    Alpine.data("initQRCodeGenerator", () => ({
        qrCode: "",

        generate(groupId) {
            fetch(`/generate-qr/${groupId}`)
                .then((res) => res.text())
                .then((svg) => {
                    this.qrCode = svg;
                })
                .catch(console.error);
        },
    }));
}
